import script from "./ConversationDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationDrawer.vue?vue&type=style&index=0&id=5ba33838&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ba33838"]])

export default __exports__